import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-regelungen',
    templateUrl: './regelungen.component.html',
    styleUrls: ['./regelungen.component.scss'],
    standalone: false
})
export class RegelungenComponent implements OnInit {
    today: Date = new Date();
    constructor () { }

    ngOnInit (): void {
    }
}
